import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getInvTitle = () => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_TITLE}`);
};

export const billing_expense_getInvTitleByCompany = (query) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_TITLE}` + `/getbycompany`, query);
};

export const billing_expense_getInvTitleByDep = (dep_id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_TITLE}` + `/get-by-dep_id/${dep_id}`);
};


export const billing_expense_getInvTitleByID = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_TITLE}/get-by-id/${id}`);
};
export const billing_expense_getInvTitleByDepPagination = (
    dep_id,
    page,
    limit,
    sortBy,
    sortOrder,
    title
) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.INVOICE_TITLE}/get-by-dep_id-pagination/${dep_id}`,
        {
            params: {
                page,
                limit,
                sortBy,
                sortOrder,
                title,
            },
        }
    );
};

export const billing_expense_addInvTitle = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.INVOICE_TITLE}`, data);
};

export const billing_expense_UpdateInvTitle = (id, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.INVOICE_TITLE}/${id}`, data);
};

export const billing_expense_DeleteInvTitle = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.INVOICE_TITLE}/${id}`);
};